import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { IconButtonComponent, IconComponent, TooltipDirective } from '@mode/capra';
import { SharedUiModule } from '@mode/shared/ui';
import { BigValueRendererComponent } from './big-value/big-value-renderer.component';
import { ChartOptionsMenuComponent } from './chart-options-menu/chart-options-menu.component';
import { FacetPagingComponent } from './facet-paging/facet-paging.component';
import { FieldTreeViewComponent } from './field-tree-view/field-tree-view.component';
import { FillerBusterComponent } from './filler-buster/filler-buster.component';
import { InPlaceInputComponent } from './inputs/in-place-input.component';
import { InPlaceTextareaComponent } from './inputs/in-place-textarea.component';
import { TableRendererComponent } from './table-renderer/table-renderer.component';
import { TreeViewComponent } from './field-tree-view/tree-view/tree-view.component';
import { VisualizationMenuComponent } from './visualization-menu/visualization-menu.component';
import { VizRendererComponent } from './viz-renderer/viz-renderer.component';
import { VizLoaderComponent } from './viz-loader/viz-loader.component';

@NgModule({
  imports: [
    ChartOptionsMenuComponent,
    CommonModule,
    FacetPagingComponent,
    FormsModule,
    IconButtonComponent,
    IconComponent,
    InPlaceInputComponent,
    InPlaceTextareaComponent,
    SharedUiModule,
    TooltipDirective,
    TreeViewComponent,
    MatLegacyMenuModule,
    VizLoaderComponent,
  ],
  declarations: [
    BigValueRendererComponent,
    FieldTreeViewComponent,
    FillerBusterComponent,
    TableRendererComponent,
    VizRendererComponent,
    VisualizationMenuComponent,
  ],
  exports: [
    BigValueRendererComponent,
    ChartOptionsMenuComponent,
    FacetPagingComponent,
    FieldTreeViewComponent,
    InPlaceInputComponent,
    InPlaceTextareaComponent,
    TableRendererComponent,
    VizRendererComponent,
    VisualizationMenuComponent,
    VizLoaderComponent,
  ],
})
export class ChartsUiModule {}
